import {
  ISearchParams,
  SortByEnum,
  SortOrderEnum,
} from '../entity-data/entity-data.data';
import { ALL_YEARS } from '../document-data/document-data.data';

export const DONE_LIST_SEARCH_PARAMS = 'done_estimate_list_search_params';
export const PENDING_LIST_SEARCH_PARAMS = 'pending_estimate_list_search_params';

export const DEFAULT_SEARCH_PARAMS: ISearchParams = Object.freeze({
  sort_by: SortByEnum.doc_date,
  sort_order: SortOrderEnum.desc,
  document_tax_year: ALL_YEARS,
});

export enum EstimateFiltersEnum {
  done = 'done',
  pending = 'pending',
}

export enum EstimateStatusesEnum {
  approved = 'approved',
  declined = 'declined',
  pending = 'pending',
}
